export enum ChartType {
  Base = 'base',
  LineStock = 'lineStock',
  HorizontalColumn = 'horizontalColumn',
  PersentageColumn = 'persentageColumn',
  VerticalColumn = 'verticalColumn',
  VerticalPercentageColumn = 'verticalPercentageColumn',
  VerticalCurrencyColumn = 'verticalCurrencyColumn',
}
